import React, { useState, useEffect } from 'react';
import { Table, Button, Tag, Popconfirm, Space, Typography, Image, Avatar } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined, EyeOutlined } from '@ant-design/icons';
import api from '../api';

const { Title, Text } = Typography;

function MomentManagePage() {
  const [moments, setMoments] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const loadMoments = async (p = 1) => {
    setLoading(true);
    try {
      const { list, total: t } = await api.get('/admin/moments', { params: { page: p, limit: 20 } });
      setMoments(list);
      setTotal(t);
      setPage(p);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadMoments(); }, []);

  const handleDelete = async (id) => {
    await api.delete(`/admin/moments/${id}`);
    loadMoments(page);
  };

  const privacyMap = {
    public: { label: '公开', color: 'green' },
    friends: { label: '仅好友', color: 'blue' },
    private: { label: '仅自己', color: 'orange' },
  };

  const columns = [
    { title: 'ID', width: 80, data: 'id' },
    {
      title: '发布者', width: 140,
      render: (_, r) => (
        <Space>
          <Avatar size="small" src={r.avatar} />
          <span>{r.nickname}</span>
        </Space>
      ),
    },
    { title: '内容', dataIndex: 'content', ellipsis: true, width: 300 },
    {
      title: '图片', width: 120,
      render: (_, r) => {
        try {
          const imgs = r.images ? JSON.parse(r.images) : [];
          if (imgs.length > 0) return <Image.PreviewGroup>{imgs.slice(0, 3).map((url, i) => <Image key={i} src={url} width={40} height={40} style={{ objectFit: 'cover', marginRight: 4 }} />)}</Image.PreviewGroup>;
          return <Text type="secondary">无图片</Text>;
        } catch { return <Text type="secondary">解析失败</Text>; }
      },
    },
    {
      title: '可见范围', width: 100,
      render: (_, r) => <Tag color={privacyMap[r.privacy]?.color}>{privacyMap[r.privacy]?.label || r.privacy}</Tag>,
    },
    { title: '发布时间', dataIndex: 'created_at', width: 160, render: (v) => v ? new Date(v).toLocaleString() : '-' },
    {
      title: '操作', width: 100,
      render: (_, r) => (
        <Popconfirm title="确定删除该动态?" onConfirm={() => handleDelete(r.id)} icon={<ExclamationCircleOutlined style={{ color: 'red' }} />}>
          <Button size="small" danger icon={<DeleteOutlined />}>删除</Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={4}>朋友圈管理</Title>
        <Text type="secondary">共 {total} 条动态</Text>
      </div>
      <Table
        columns={columns}
        dataSource={moments}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={{ current: page, total, pageSize: 20, onChange: loadMoments, showSizeChanger: false }}
      />
    </>
  );
}

export default MomentManagePage;
